import React from 'react';
import { connect } from 'react-redux';
// LevelEditor imports
import { itemSelectorToggle, toggleBackgroundMode } from '../../../../actions/levelEditorActions';
import { BackgroundCategoryString } from '../../../../../GameKit/shared';
// Game(kit) imports
import gameKit from '../../../../../GameKit';
import settings from '../../../../../settings';

class BtnExpand extends React.Component {
    handleClick = () => {
        const { levelEditor, dispatch } = this.props;
        dispatch(itemSelectorToggle());
        if (levelEditor.itemSelectorCurrentCategory === BackgroundCategoryString) {
            dispatch(toggleBackgroundMode());
            gameKit.levelEditor.startTileMode();
        }
    };

    render = () => {
        const { levelEditor } = this.props;

        const activeClass = levelEditor.itemSelectorOpen ? '' : 'active';

        return (
            <div className={`btn-item-selector-open-wrapper ${activeClass}`}>
                <div className="btn-item-selector-open-container" onClick={this.handleClick}>
                    <div className="image-container">
                        <img src={`${settings.assetsPath}img/icons/bouwen.png`} alt="Bouwen" title="Bouwen" />
                    </div>
                    <span>bouwen</span>
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BtnExpand);
